export const LANG_PROPER_NAME = "proper";

export const LANG_PROPER_TRANS = {
	"application.title": "SafeConnect SDP",
	"company.name": "Impulse Point, LLC.",
	"download.media.mat5": "MD5",
};
